module.exports = __webpack_public_path__ + "img/sign_content.e8ba6d2c.png";